import { FaGithub, FaLinkedin, FaMedium, FaEnvelope } from 'react-icons/fa';

const socialIcons = {
  GitHub: FaGithub,
  LinkedIn: FaLinkedin,
  Medium: FaMedium,
  Email: FaEnvelope,
};

export default socialIcons;
